import { render, staticRenderFns } from "./CustomerNotesListItem.vue?vue&type=template&id=3a1e2c49&scoped=true&lang=pug&"
import script from "./CustomerNotesListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerNotesListItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNotesListItem.vue?vue&type=style&index=0&id=3a1e2c49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1e2c49",
  null
  
)

/* custom blocks */
import block0 from "./CustomerNotesListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports